export default __webpack_public_path__ + "static/media/logo-with-tagline1.b2e21c8a.png";